import { useEffect, useState } from "react";

/**
 * Live-updating local time with timezone abbreviation.
 * Renders "12:13:27 PM MDT" style — matches the reference aesthetic.
 *
 * Updates once per second on a setInterval. Cleaned up on unmount.
 */
export default function TimezoneClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const time = now.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  // Derive timezone abbreviation (PST, MDT, etc.) from the long form.
  const tzMatch = now.toString().match(/\(([^)]+)\)$/);
  const tzAbbrev =
    tzMatch?.[1]
      ?.split(/\s+/)
      .map((w) => w[0])
      .join("") ?? "";

  return (
    <span className="font-mono text-xs text-gray-500 tabular-nums">
      {time}
      {tzAbbrev && <span className="ml-1.5 text-gray-400">{tzAbbrev}</span>}
    </span>
  );
}
